import React, { useState } from "react";
import { Link } from "react-router-dom";
import { LayoutGrid, X, ChevronLeft, ChevronRight } from "lucide-react";
import { GALLERY_IMAGES } from "../mock/mock";

export default function OurTownhouses() {
  const [idx, setIdx] = useState(null);
  const open = idx !== null;
  const close = () => setIdx(null);
  const prev = () => setIdx((i) => (i === 0 ? GALLERY_IMAGES.length - 1 : i - 1));
  const next = () => setIdx((i) => (i === GALLERY_IMAGES.length - 1 ? 0 : i + 1));

  return (
    <section id="townhouses" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto text-center mb-14">
        <div className="text-[11px] tracking-[0.3em] uppercase text-forge-gold">A Look Inside</div>
        <h2 className="font-serif text-4xl md:text-5xl text-forge-navy mt-2">Life at Forge Stays</h2>
        <hr className="forge-divider" />
        <p className="text-forge-navy/70 max-w-2xl mx-auto">
          A closer look at our Anglesey properties — Newry Street in Holyhead and Hotel Cymyran in Valley.
        </p>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-3 gap-3">
        {GALLERY_IMAGES.map((img, i) => (
          <div key={i} className="gallery-item aspect-[4/3]" onClick={() => setIdx(i)}>
            <img src={img.src} alt={img.alt} loading="lazy" />
            <div className="absolute inset-0 bg-forge-navy/0 hover:bg-forge-navy/25 transition-colors" />
          </div>
        ))}
      </div>

      <div className="mt-10 flex justify-center">
        <Link to="/gallery" className="btn-navy"><LayoutGrid size={16} /> View Full Gallery</Link>
      </div>

      {open && (
        <div className="fixed inset-0 z-[60] bg-black/85 flex items-center justify-center p-4" onClick={close}>
          <button className="absolute top-5 right-5 text-white/90 hover:text-white" onClick={close} aria-label="Close">
            <X size={30} />
          </button>
          <button className="absolute left-5 md:left-10 text-white/80 hover:text-white"
                  onClick={(e) => { e.stopPropagation(); prev(); }} aria-label="Previous">
            <ChevronLeft size={40} />
          </button>
          <img src={GALLERY_IMAGES[idx].src} alt={GALLERY_IMAGES[idx].alt}
               className="max-h-[85vh] max-w-[92vw] object-contain" onClick={(e) => e.stopPropagation()} />
          <button className="absolute right-5 md:right-10 text-white/80 hover:text-white"
                  onClick={(e) => { e.stopPropagation(); next(); }} aria-label="Next">
            <ChevronRight size={40} />
          </button>
          <div className="absolute bottom-6 left-0 right-0 text-center text-white/85 text-sm tracking-wide">
            {GALLERY_IMAGES[idx].caption}
          </div>
        </div>
      )}
    </section>
  );
}
